<template>
  <div class="tw-relative">
    <apexchart
      :class="'score-chart-short'"
      :style="``"
      :width="width"
      type="radialBar"
      :options="optionsCurrent"
      :series="[currentScore * 100]"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    currentScore?: number;
    potentialScore?: number;
    pcntScore?: number;
    isLoading?: boolean;
    noteColor?: string;
    currentScoreColor?: string;
    totalScoreColor?: string;
    width?: number;
  }>(),
  {
    currentScore: 0,
    potentialScore: 0,
    pcntScore: 0,
    noteColor: "#211f58",
    currentScoreColor: "#48A0FF",
    totalScoreColor: "#D9EDE2",
    width: 150,
  },
);

const optionsCurrent = computed(() => ({
  colors: [props.currentScoreColor],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "75%",
      },
      track: {
        strokeWidth: "90%",
        background: props.totalScoreColor,
        opacity: 1,
        show: true,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
          color: props.currentScoreColor,
          fontSize: "20px",
          fontWeight: 500,
          fontFamily: "Poppins",
          offsetY: 5,
          offsetX: 3,
          formatter: () => `${Math.round(props.pcntScore * 100)}%`,
        },
      },
    },
  },
  stroke: {
    show: true,
    lineCap: "round",
    opacity: 1,
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));
</script>

<style scoped lang="scss">
.score-chart-short {
  // position: absolute;
  &:deep(g[class*="apexcharts-radial-series"]) {
    & > path {
      filter: unset !important;
      stroke-width: 10px !important;
    }
  }

  &:deep(g[class*="apexcharts-radialbar-track"]) {
    & > path {
      filter: unset !important;
      stroke-width: 10px !important;
    }
  }
}
</style>
